import React, { useMemo } from 'react';

import MerchantSelect from '@components/operator/MerchantSelect';
import InventoryHoldNew from '@components/shared/inventory/InventoryHoldNew';
import { useOperatorData } from '@contexts/operator/OperatorDataContext';
import { useOperatorProductService } from '@hooks/operator/products/useOperatorProductService';
import { inventoryHoldService } from '@services/operator/inventoryHoldService';

interface MerchantInventoryTypeRow {
  inventory_type: {
    id: string;
    name?: string;
    code?: string;
    [key: string]: unknown;
  };
  [key: string]: unknown;
}

const InventoryHoldNewContent: React.FC = () => {
  const operatorData = useOperatorData() as {
    merchantId?: string;
    merchantInventoryTypes?: MerchantInventoryTypeRow[];
  };
  const productService = useOperatorProductService();

  // Operator stores merchant-inventory-types as { merchant_id, inventory_type, ... };
  // OrderItemsCard wants the inner inventory_type rows directly.
  const inventoryTypes = useMemo(() => {
    return (operatorData.merchantInventoryTypes ?? [])
      .map(row => row.inventory_type)
      .filter(Boolean);
  }, [operatorData.merchantInventoryTypes]);

  // A1 narrow：MerchantSelect 已 gate 過，但這裡仍須收斂 merchantId 為 string
  // 以避免把 undefined 透傳給 shared <InventoryHoldNew>（其 prop 為 required string）
  const { merchantId } = operatorData;
  if (!merchantId) return null;

  return (
    <InventoryHoldNew
      role="operator"
      service={inventoryHoldService}
      merchantId={merchantId}
      productService={productService}
      inventoryTypes={inventoryTypes}
    />
  );
};

const InventoryHoldNewPage: React.FC = () => {
  return (
    <MerchantSelect>
      <InventoryHoldNewContent />
    </MerchantSelect>
  );
};

export default InventoryHoldNewPage;
